<template>
  <span class="ui-badge" :class="[`ui-badge--${tone}`, `ui-badge--${size}`]">
    <hs-icon v-if="icon" :name="icon" :size="iconSize" />
    <slot />
  </span>
</template>

<script>
import HsIcon from "./HsIcon.vue";

export default {
  name: "HsBadge",
  components: { HsIcon },
  props: {
    tone: {
      type: String,
      default: "neutral",
      validator: (value) => ["neutral", "primary", "success", "warning", "danger", "info"].includes(value),
    },
    size: {
      type: String,
      default: "md",
      validator: (value) => ["sm", "md"].includes(value),
    },
    icon: {
      type: String,
      default: "",
    },
  },
  computed: {
    iconSize() {
      return this.size === "sm" ? 12 : 14;
    },
  },
};
</script>

<style scoped>
.ui-badge {
  align-items: center;
  border-radius: 999px;
  display: inline-flex;
  font-weight: 950;
  gap: 0.35rem;
  line-height: 1;
  white-space: nowrap;
}

.ui-badge--sm {
  font-size: 0.68rem;
  padding: 0.28rem 0.48rem;
}

.ui-badge--md {
  font-size: 0.75rem;
  padding: 0.42rem 0.65rem;
}

.ui-badge--neutral {
  background: color-mix(in srgb, var(--hs-muted, #64748b) 12%, transparent);
  color: var(--hs-text, #0f172a);
}

.ui-badge--primary {
  background: color-mix(in srgb, var(--hs-primary, #3293ec) 12%, transparent);
  color: var(--hs-primary, #3293ec);
}

.ui-badge--success {
  background: color-mix(in srgb, #22c55e 14%, transparent);
  color: #15803d;
}

.ui-badge--warning {
  background: color-mix(in srgb, #f59e0b 16%, transparent);
  color: #b45309;
}

.ui-badge--danger {
  background: color-mix(in srgb, #ef4444 13%, transparent);
  color: #dc2626;
}

.ui-badge--info {
  background: color-mix(in srgb, #06b6d4 14%, transparent);
  color: #0891b2;
}
</style>
